
// normal.day - exibe o mapa de vias padrão. Esse é o tipo de mapa padrão.
// satellite.day - exibe imagens de satélite do Google Earth
// hybrid.day - exibe uma combinação de visualizações normais e de satélite
// terrain.day - exibe um mapa físico baseado em informações do terreno.
// ... entre outros


/**
 * @enum {string}
 */
export default {
  ROADMAP: 'normal.day',
  SATELLITE: 'satellite.day',
  HYBRID: 'hybrid.day',
  TERRAIN: 'terrain.day',
};
